/**
 * Privacy-first local participation tracker.
 * Records which match IDs THIS fan contributed to (took, appreciated, gauged,
 * or predicted) — purely in localStorage, no backend, no identity exposure.
 */

export const PARTICIPATION_KEY = 'coyg_participated';

/** Mark that the current fan participated in a match. Idempotent. */
export function markParticipated(matchId: string): void {
  try {
    const raw = localStorage.getItem(PARTICIPATION_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    const existing = Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string').slice(-199) : [];
    if (!existing.includes(matchId)) {
      existing.push(matchId);
      localStorage.setItem(PARTICIPATION_KEY, JSON.stringify(existing));
    }
    window.dispatchEvent(new Event('coyg:participation-changed'));
  } catch {
    /* storage unavailable (private mode, quota, SSR) — silently swallow */
  }
}

/** Returns true if the current fan participated in this match. */
export function wasParticipated(matchId: string): boolean {
  try {
    const raw = localStorage.getItem(PARTICIPATION_KEY);
    if (!raw) return false;
    const existing = JSON.parse(raw) as string[];
    return existing.includes(matchId);
  } catch {
    return false;
  }
}
